import { apiUtils } from "../../../../utils/apiUtils";
import {
  MerchantCouponCreateApiRequest,
  MerchantCouponCreateRawApiResponse,
  MerchantCouponDetailRawApiResponse,
  MerchantCouponUpdateApiRequest,
  MerchantCouponUIState,
  mapRawDetailResponseToUI,
  mapUIToCreateRequest,
  mapUIToUpdateRequest,
} from "../data/merchantCouponEditor.data";

interface UploadAnswerFileResponse {
  urls: string[];
}

interface MerchantCouponUpdateRawApiResponse {
  coupon_id: string;
  title: string;
  message: string;
}

export const uploadCouponImage = async (
  file: File,
  signal?: AbortSignal,
): Promise<string> => {
  const formData = new FormData();
  formData.append("files", file);

  const response = await apiUtils.postWithFormData<UploadAnswerFileResponse>(
    "/v1/survey/upload-answer-file",
    formData,
    { signal },
  );
  const data = apiUtils.unwrap(response, "Failed to upload coupon image");
  const urls = data.urls;

  if (!urls || !Array.isArray(urls) || urls.length === 0) {
    throw new Error("Upload failed: No URL returned");
  }

  return urls[0];
};

export const createMerchantCoupon = async (
  uiData: MerchantCouponUIState,
): Promise<void> => {
  const createRequest = mapUIToCreateRequest(uiData);
  await apiUtils.postData<
    MerchantCouponCreateRawApiResponse,
    MerchantCouponCreateApiRequest
  >(
    "/v1/merchant/local-merchant-coupon",
    createRequest,
    "Failed to create merchant coupon",
  );
};

export const fetchMerchantCouponDetail = async (
  couponId: string,
  signal?: AbortSignal,
): Promise<MerchantCouponUIState> => {
  const rawData = await apiUtils.getData<MerchantCouponDetailRawApiResponse>(
    `/v1/merchant/local-merchant-coupon/${couponId}`,
    "Failed to fetch merchant coupon detail",
    { signal },
  );

  return mapRawDetailResponseToUI(rawData);
};

export const updateMerchantCoupon = async (
  couponId: string,
  uiData: MerchantCouponUIState,
): Promise<void> => {
  const updateRequest = mapUIToUpdateRequest(uiData);
  await apiUtils.putData<
    MerchantCouponUpdateRawApiResponse,
    MerchantCouponUpdateApiRequest
  >(
    `/v1/merchant/local-merchant-coupon/${couponId}`,
    updateRequest,
    "Failed to update merchant coupon",
  );
};

